export const AgreementBasedOn = {
  Specialization: "Specialization",
  Degree: "Degree",
};
